import { render, staticRenderFns } from "./MobileAppUpdateModal.vue?vue&type=template&id=ca0fd1ce"
import script from "./MobileAppUpdateModal.vue?vue&type=script&lang=js"
export * from "./MobileAppUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports